import type { AllRouteEndpoints } from "../routeTypes";
export const inboxVisionAppGroupIdSetDefaultPreviewIdsCacheKeys: AllRouteEndpoints[] = [
  "/inbox_vision/:app_group_id/get_inbox_vision_data",
];
